import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import NavbarDropshipping from '../navbarDropshipping/navbarDropshipping';
import { Button, message } from 'antd'; // Añadir estas importaciones
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from 'axios';
import './LandingDrop.css';
import SendClientCart from "../SendClientPage/SendClientCart";
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import FilterListIcon from '@mui/icons-material/FilterList';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import DeleteIcon from '@mui/icons-material/Delete';
import { ArrowRightOutlined, ArrowLeftOutlined, ShopOutlined, ShoppingCartOutlined } from '@ant-design/icons';

// Add slider settings definition
const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  lazyLoad: 'ondemand'
};

const calcularPrecioConComision = (precio) => {
  const precioBase = parseFloat(precio);
  const comision = parseFloat(localStorage.getItem('porcentaje_comision')) || 0;
  // Primero convertir el porcentaje a decimal (ej: 1.5% -> 0.015)
  const comisionDecimal = comision / 100;
  // Luego calcular el valor de la comisión
  const valorComision = precioBase * comisionDecimal;
  
  return precioBase + valorComision;
};

const capitalizarPalabras = (texto) => {
  const palabrasMinusculas = ['de', 'para', 'que', 'con'];
  
  return texto.toLowerCase().replace(/(?:[-+])?[^\s-+]+/g, function(palabra) {
    // Si la palabra empieza con - o +, mantener el símbolo y capitalizar la palabra
    if (palabra.match(/^[-+]/)) {
      const simbolo = palabra[0];
      const resto = palabra.slice(1);
      return simbolo + resto.charAt(0).toUpperCase() + resto.slice(1);
    }
    
    // Si es una palabra que debe ir en minúsculas, retornarla así
    if (palabrasMinusculas.includes(palabra.toLowerCase())) {
      return palabra.toLowerCase();
    }
    
    // Para el resto de palabras, capitalizar la primera letra
    return palabra.charAt(0).toUpperCase() + palabra.slice(1);
  });
};

const LandingDrop = () => {
  // Eliminamos estados para envío individual
  // const [mostrarEnvios, setMostrarEnvios] = useState(false);
  const [suggestedPrice, setSuggestedPrice] = useState(null);
  const [name, setName] = useState(null);
  const [stock, setStock] = useState(null);
  const [prodID, setProdID] = useState(null);
  const [products, setProducts] = useState([]); // Todos los productos
  const [filteredProducts, setFilteredProducts] = useState([]); // Productos filtrados
  const [categories, setCategories] = useState([]);
  const [providers, setProviders] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedProvider, setSelectedProvider] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(''); // Estado para el término de búsqueda
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 20;
  const [loadingMessage, setLoadingMessage] = useState('');
  const [progress, setProgress] = useState(0);
  const [showFiltersModal, setShowFiltersModal] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('dropshippingCart');
    return savedCart ? JSON.parse(savedCart) : [];
  });
  const [showCart, setShowCart] = useState(false);
  const [mostrarEnviosCarrito, setMostrarEnviosCarrito] = useState(false);
  const [lastCartUpdate, setLastCartUpdate] = useState(null);

  const loadingMessages = [
    "¡Ya casi! Solo nos falta un 1% para empezar a pedir",
    "Cargando los mejores productos para ti",
    "Preparando una experiencia increíble",
    "Organizando los productos más vendidos",
    "¡Los precios más competitivos están en camino!",
    "Casi todo listo para empezar",
  ];

  const rotateLoadingMessage = useCallback(() => {
    const interval = setInterval(() => {
      setLoadingMessage(prevMessage => {
        const currentIndex = loadingMessages.indexOf(prevMessage);
        const nextIndex = (currentIndex + 1) % loadingMessages.length;
        return loadingMessages[nextIndex];
      });
      setProgress(prev => (prev + 10) % 100);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isLoading) {
      setLoadingMessage(loadingMessages[0]);
      const cleanup = rotateLoadingMessage();
      return () => cleanup();
    }
  }, [isLoading, rotateLoadingMessage]);

  // Almacena todos los productos en la primera carga
  const fetchProducts = useCallback(async () => {
    // Primero, intentar obtener productos del localStorage
    const cachedProducts = localStorage.getItem('cachedProducts');
    const lastFetch = localStorage.getItem('lastProductsFetch');
    const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos en milisegundos

    // Si hay productos en caché y no han pasado más de 5 minutos
    if (cachedProducts && lastFetch && (Date.now() - parseInt(lastFetch) < CACHE_DURATION)) {
      const parsedProducts = JSON.parse(cachedProducts);
      setProducts(parsedProducts);
      setFilteredProducts(parsedProducts);
      const uniqueCategories = [...new Set(parsedProducts.map(product => product.category))];
      const uniqueProviders = [...new Set(parsedProducts.map(product => product.provider))];
      setCategories(uniqueCategories);
      setProviders(uniqueProviders);
      return;
    }

    setIsLoading(true);
    try {
      const { data } = await axios.get('https://api.99envios.app/api/inventarios');
      const productPromises = data
        .filter(product => product.activo === 1)
        .map(async (product) => {
          const detailResponse = await axios.get(`https://api.99envios.app/api/inventarios_producto/${product.id_producto}`);
          const { inventario, sucursal } = detailResponse.data;
          
          if (!sucursal) {
            console.error('Sucursal no encontrada para producto:', product.id_producto);
            return null;
          }

          return {
            id: product.id_producto,
            name: product.nombre_producto,
            category: product.categoria?.nombre_categoria || 'Sin categoría',
            stock: product.cantidad_disponible,
            provider: sucursal.nombre_sucursal || 'Sin proveedor',
            supplierPrice: parseFloat(product.precio_proveedor),
            suggestedPrice: parseFloat(product.precio_sugerido),
            images: product.imagenes.map(img => img.url_imagen) || ['/logo.png'],
            link: `/product/${product.id_producto}`,
            activo: product.activo,
            variaciones: inventario.variaciones || [],
            sucursal_id: sucursal.codigo_sucursal,
            origin_city_id: sucursal.id_ciudad,
            id_ciudad: sucursal.id_ciudad
          };
      });

      const mappedProducts = (await Promise.all(productPromises)).filter(product => product !== null);
      const shuffledProducts = mappedProducts.sort(() => Math.random() - 0.5);
      
      // Guardar en localStorage
      localStorage.setItem('cachedProducts', JSON.stringify(shuffledProducts));
      localStorage.setItem('lastProductsFetch', Date.now().toString());
      
      setProducts(shuffledProducts);
      setFilteredProducts(shuffledProducts);
      const uniqueCategories = [...new Set(shuffledProducts.map(product => product.category))];
      const uniqueProviders = [...new Set(shuffledProducts.map(product => product.provider))];
      setCategories(uniqueCategories);
      setProviders(uniqueProviders);
    } catch (error) {
      console.error('Error al cargar productos:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts(); // Obtener los productos en el montaje inicial
  }, [fetchProducts]);

  // Función de filtrado
  useEffect(() => {
    const filterProducts = () => {
      const filtered = products.filter(product => {
        const categoryMatch = selectedCategory ? product.category === selectedCategory : true;
        const providerMatch = selectedProvider ? product.provider === selectedProvider : true;
        const searchTermMatch = product.name.toLowerCase().includes(searchTerm.toLowerCase());
        const priceMatch = 
          (!minPrice || product.suggestedPrice >= parseFloat(minPrice)) &&
          (!maxPrice || product.suggestedPrice <= parseFloat(maxPrice));
        return categoryMatch && providerMatch && searchTermMatch && priceMatch;
      });
      setFilteredProducts(filtered);
      setCurrentPage(1); // Resetear a la primera página cuando se filtran los productos
    };

    filterProducts();
  }, [selectedCategory, selectedProvider, searchTerm, minPrice, maxPrice, products]);

  // Calcular productos para la página actual
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  // Función para cambiar de página
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Componente de paginación
  const Pagination = () => (
    <div className="pagination">
      <button 
        onClick={() => paginate(currentPage - 1)} 
        disabled={currentPage === 1}
        className="pagination-btn"
      >
        ← Anterior
      </button>
      <span className="page-info">
        Página {currentPage} de {totalPages}
      </span>
      <button 
        onClick={() => paginate(currentPage + 1)} 
        disabled={currentPage === totalPages}
        className="pagination-btn"
      >
        Siguiente →
      </button>
    </div>
  );

  // Se elimina el handleButtonClick y el modal para envío individual. Solo se trabaja con el carrito.

  const addToCart = (product) => {
    setCart(prevCart => {
      const existing = prevCart.find(item => item.id === product.id);
      if (existing) {
        return prevCart.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prevCart, { 
        ...product, 
        quantity: 1,
        sucursal_id: product.sucursal_id,
        origin_city_id: product.id_ciudad, // Incluimos el id_ciudad
        variaciones: product.variaciones || []
      }];
    });
    setShowCart(true);
    message.success('Producto agregado al carrito');
  };

  const removeFromCart = (productId) => {
    setCart(prevCart => prevCart.filter(item => item.id !== productId));
  };

  const updateQuantity = (productId, newQuantity) => {
    if (newQuantity < 1) {
      removeFromCart(productId);
      return;
    }
    setCart(prevCart =>
      prevCart.map(item =>
        item.id === productId
          ? { ...item, quantity: newQuantity }
          : item
      )
    );
  };

  // const updateWeight = (productId, weight) => {
  //   setWeights(prev => ({
  //     ...prev,
  //     [productId]: parseFloat(weight) || 0
  //   }));
  // };

  const ProductCard = React.memo(({ product }) => (
    <div className="product-cardL">
      <div className="product-carousel">
        {product.images.length > 1 ? (
          <Slider {...settings}>
            {product.images.map((image, index) => (
              <div key={index}>
                <Link to={product.link}>
                  <img src={image} alt={product.name} loading="lazy" />
                </Link>
              </div>
            ))}
          </Slider>
        ) : (
          <Link to={product.link}>
            <img src={product.images[0] || "/logo.png"} alt={product.name} loading="lazy" />
          </Link>
        )}
      </div>
      <div className="product-details">
        {/* Aquí se muestra la categoría y el id del producto */}
        <p className="category">{product.category} - id: {product.id}</p>
        <p className="stock">Stock <span>{product.stock}</span></p>
        <h3>{capitalizarPalabras(product.name)}</h3>
        <p className="provider">Proveedor: <span>{product.provider}</span></p>
        <p className="supplier-price">Precio proveedor: ${calcularPrecioConComision(product.supplierPrice).toLocaleString()}</p>
        <p className="suggested-price">Precio sugerido: <strong>${calcularPrecioConComision(product.suggestedPrice).toLocaleString()}</strong></p>
      </div>
      <div className="product-card-buttons">
        <button className="add-to-cart-btn" onClick={() => addToCart(product)}>
          Agregar al carrito
        </button>
        {/* <button className="send-client-btn" onClick={() => handleButtonClick(product.suggestedPrice, product.stock, product.name, product.id)}>
          Enviar al cliente
        </button> */}
      </div>
    </div>
  ));

  const FiltersModal = () => (
    <div className="modal-overlay" onClick={() => setShowFiltersModal(false)}>
      <div className="filters-modal" onClick={e => e.stopPropagation()}>
        <div className="filters-modal-header">
          <h3>Filtros</h3>
          <button onClick={() => setShowFiltersModal(false)} className="close-modal-btn">
            <CloseIcon />
          </button>
        </div>
        <div className="filters-modal-content-drop">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="🔍 Buscar productos..."
            className="search-input"
          />
          <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
            <option value="">📁 Todas las categorías</option>
            {categories.map((category, index) => (
              <option key={index} value={category}>{category}</option>
            ))}
          </select>
          <select value={selectedProvider} onChange={(e) => setSelectedProvider(e.target.value)}>
            <option value="">🏢 Todos los proveedores</option>
            {providers.map((provider, index) => (
              <option key={index} value={provider}>{provider}</option>
            ))}
          </select>
          <input
            type="number"
            value={minPrice}
            onChange={(e) => setMinPrice(e.target.value)}
            placeholder="$ Precio mínimo"
            className="price-input"
          />
          <input
            type="number"
            value={maxPrice}
            onChange={(e) => setMaxPrice(e.target.value)}
            placeholder="$ Precio máximo"
            className="price-input"
          />
        </div>
      </div>
    </div>
  );

  const Cart = () => (
    <div className={`floating-cart ${showCart ? 'show' : ''}`}>
      <div className="cart-header">
        <h3>Carrito <span>({cart.length})</span></h3>
        <button onClick={() => setShowCart(false)} className="close-cart-btn">
          <CloseIcon />
        </button>
      </div>
      <div className="cart-items">
        {cart.map(item => (
          <div key={item.id} className="cart-item">
            <img src={item.images[0]} alt={item.name} />
            <div className="cart-item-details">
              <h4>{item.name}</h4>
              {/* Se actualiza para mostrar el precio con comisión */}
              <p>${calcularPrecioConComision(item.suggestedPrice).toLocaleString()}</p>
              <div className="quantity-controls">
                <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>
                  {item.quantity === 1 ? <DeleteIcon fontSize="small" /> : '-'}
                </button>
                <span>{item.quantity}</span>
                <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
              </div>
            </div>
            <button onClick={() => removeFromCart(item.id)} className="remove-item">
              <CloseIcon />
            </button>
          </div>
        ))}
      </div>
      {cart.length > 0 ? (
        <div className="cart-footer">
          <div className="cart-total">
            <span>Total:</span>
            {/* Se actualiza el total para incluir el precio con comisión */}
            <span>${cart.reduce((total, item) => total + (calcularPrecioConComision(item.suggestedPrice) * item.quantity), 0).toLocaleString()}</span>
          </div>
          <button 
            className="checkout-btn" 
            onClick={() => {
              setMostrarEnviosCarrito(true);
              setShowCart(false);
            }}
          >
            Proceder al envío
          </button>
        </div>
      ) : (
        <p className="empty-cart">El carrito está vacío</p>
      )}
    </div>
  );

  // Función para agrupar por ciudad de origen
  const groupCartByCity = (cartItems) => {
    const groups = cartItems.reduce((acc, item) => {
      const cityId = item.origin_city_id;
      if (!acc[cityId]) {
        acc[cityId] = {
          id_ciudad: cityId,
          sucursales: {}
        };
      }
      
      const sucursalId = item.sucursal_id;
      if (!acc[cityId].sucursales[sucursalId]) {
        acc[cityId].sucursales[sucursalId] = {
          sucursal_id: sucursalId,
          sucursal_nombre: item.provider,
          items: []
        };
      }
      
      acc[cityId].sucursales[sucursalId].items.push(item);
      return acc;
    }, {});

    // Convertir el objeto en un array de ciudades
    return Object.entries(groups).map(([cityId, cityGroup]) => ({
      id_ciudad: cityId,
      // Convertir el objeto de sucursales en un array
      sucursales: Object.values(cityGroup.sucursales)
    }));
  };

  const CartCheckoutModals = () => {
    const [currentCityIndex, setCurrentCityIndex] = useState(0);
    const groupedCart = groupCartByCity(cart);
    const totalCities = groupedCart.length;
  
    useEffect(() => {
      if (totalCities > 1) {
        message.info({
          content: (
            <div>
              <h4 style={{ marginBottom: '8px' }}>Productos de diferentes ciudades</h4>
              <p>Tienes productos de {totalCities} ciudades diferentes.</p>
              <p>Se procesarán por separado para optimizar el envío.</p>
            </div>
          ),
          duration: 10,
          style: {
            width: '400px'
          }
        });
      }
    }, [totalCities]);
  
    if (groupedCart.length === 0) return null;
  
    const currentCity = groupedCart[currentCityIndex];
    const allItemsInCity = currentCity.sucursales.reduce((items, sucursal) => [...items, ...sucursal.items], []);
    const totalItemsInCity = allItemsInCity.length;
  
    const handleNext = () => {
      if (currentCityIndex < totalCities - 1) {
        setCurrentCityIndex(prev => prev + 1);
      }
    };
  
    const handlePrevious = () => {
      if (currentCityIndex > 0) {
        setCurrentCityIndex(prev => prev - 1);
      }
    };
  
    const handleOrderSuccess = () => {
      // Remover todos los items de la ciudad actual
      const itemsToRemove = new Set(allItemsInCity.map(item => item.id));
      const remainingItems = cart.filter(item => !itemsToRemove.has(item.id));
      
      setCart(remainingItems);
      localStorage.setItem('dropshippingCart', JSON.stringify(remainingItems));

      let successMessage = `Orden generada para productos de la ciudad ${currentCity.id_ciudad}`;
      if (currentCity.sucursales.length > 1) {
        successMessage += ` (${currentCity.sucursales.length} sucursales)`;
      }
      message.success(successMessage);

      if (remainingItems.length === 0 || currentCityIndex === totalCities - 1) {
        setMostrarEnviosCarrito(false);
        setShowCart(false);
        if (remainingItems.length === 0) {
          localStorage.removeItem('dropshippingCart');
          message.success('¡Todos los pedidos han sido procesados!');
        }
      } else {
        setCurrentCityIndex(prev => prev + 1);
        message.info('Continuando con los productos de la siguiente ciudad...');
      }
    };
  
    return (
      <div className="modal-overlay" onClick={() => setMostrarEnviosCarrito(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          {totalCities > 1 && (
            <div className="provider-navigation">
              <div className="provider-nav-header">
                <h4>Ciudad {currentCityIndex + 1} de {totalCities}</h4>
                <div className="provider-progress">
                  {groupedCart.map((city, index) => (
                    <div key={index} className="progress-item">
                      <span 
                        className={`progress-dot ${index === currentCityIndex ? 'active' : ''} ${index < currentCityIndex ? 'completed' : ''}`}
                      />
                      <small className="progress-label">Ciudad: {city.id_ciudad}</small>
                    </div>
                  ))}
                </div>
              </div>
              <div className="provider-info">
                <h3>
                  <ShopOutlined /> Ciudad actual: {currentCity.id_ciudad}
                </h3>
                <p className="provider-description">
                  {totalItemsInCity} producto(s) en {currentCity.sucursales.length} sucursal(es)
                </p>
                {currentCity.sucursales.length > 1 && (
                  <div className="sucursales-info">
                    <p>Sucursales en esta ciudad:</p>
                    <ul>
                      {currentCity.sucursales.map((sucursal, index) => (
                        <li key={index}>{sucursal.sucursal_nombre} ({sucursal.items.length} productos)</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <div className="provider-nav-buttons">
                <Button 
                  onClick={handlePrevious} 
                  disabled={currentCityIndex === 0}
                  icon={<ArrowLeftOutlined />}
                >
                  Ciudad anterior
                </Button>
                <Button 
                  onClick={handleNext} 
                  disabled={currentCityIndex === totalCities - 1}
                  icon={<ArrowRightOutlined />}
                >
                  Siguiente ciudad
                </Button>
              </div>
            </div>
          )}
          
          <SendClientCart 
            cart={allItemsInCity}
            onOrderSuccess={handleOrderSuccess}
            setMostrarEnviosCarrito={setMostrarEnviosCarrito}
          />
          <button 
            className="close-modal-btn" 
            onClick={() => setMostrarEnviosCarrito(false)}
          >
            <CloseIcon />
          </button>
        </div>
      </div>
    );
  };
  
  useEffect(() => {
    localStorage.setItem('dropshippingCart', JSON.stringify(cart));
  }, [cart]);

  // Efecto para mostrar mensaje después de 30 segundos
  useEffect(() => {
    if (cart.length > 0) {
      setLastCartUpdate(Date.now());
      const timeoutId = setTimeout(() => {
        // const randomMessages = [
        //   "¡No dejes escapar estos productos! Completa tu compra ahora.",
        //   "¿Sabías que otros usuarios ya compraron estos productos? ¡No te quedes sin el tuyo!",
        //   "¡Excelente elección! Completa tu pedido antes de que se agote.",
        //   "Los productos te están esperando. ¡Finaliza tu compra!",
        //   "¡Gran selección! Un paso más y estos productos serán tuyos."
        // ];
        // const randomMessage = randomMessages[Math.floor(Math.random() * randomMessages.length)];
        
        message.info({
          icon: <ShoppingCartOutlined style={{ color: '#1890ff', fontSize: '20px' }} />,
          content: (
            <div style={{ 
              padding: '10px 0',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              {/* {randomMessage} */}
            </div>
          ),
          duration: 7,
          style: {
            marginTop: '10vh',
            width: '400px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            borderRadius: '8px',
          },
          className: 'custom-message'
        });
      }, 30000); // 30 segundos

      return () => clearTimeout(timeoutId);
    }
  }, [cart.length]);

  return (
    <>
      <NavbarDropshipping title="Dropshipping General" />
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-content">
            <div className="delivery-scene">
              <div className="road"></div>
              <div className="truck">
                <div className="headlight"></div>
                <div className="taillight"></div>
                <div className="details"></div>
                <div className="wheel wheel-1"></div>
                <div className="wheel wheel-2"></div>
              </div>
              <div className="package package-1" style={{left: '30%'}}></div>
              <div className="package package-2" style={{left: '50%'}}></div>
              <div className="package package-3" style={{left: '70%'}}></div>
            </div>
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
            <p className="loading-message">{loadingMessage}</p>
          </div>
        </div>
      )}
      <div className="landing-drop-container">
        <div className="header-stats">
          <div className="stat-card">
            <h3>{filteredProducts.length}</h3>
            <p>Productos</p>
          </div>
          <div className="stat-card">
            <h3>{categories.length}</h3>
            <p>Categorías</p>
          </div>
          <div class="stat-card">
            <h3>{providers.length}</h3>
            <p>Proveedores</p>
          </div>
        </div>

        {/* Desktop filters */}
        <div className="filters desktop-only">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="🔍 Buscar productos..."
            className="search-input"
          />
          <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
            <option value="">📁 Todas las categorías</option>
            {categories.map((category, index) => (
              <option key={index} value={category}>{category}</option>
            ))}
          </select>
          <select value={selectedProvider} onChange={(e) => setSelectedProvider(e.target.value)}>
            <option value="">🏢 Todos los proveedores</option>
            {providers.map((provider, index) => (
              <option key={index} value={provider}>{provider}</option>
            ))}
          </select>
          <input
            type="number"
            value={minPrice}
            onChange={(e) => setMinPrice(e.target.value)}
            placeholder="$ Precio mínimo"
            className="price-input"
          />
          <input
            type="number"
            value={maxPrice}
            onChange={(e) => setMaxPrice(e.target.value)}
            placeholder="$ Precio máximo"
            className="price-input"
          />
        </div>

        {/* Mobile filter button */}
        <button 
          className="filter-button-mobile"
          onClick={() => setShowFiltersModal(true)}
        >
          <FilterListIcon /> 
        </button>

        <div className="product-grid">
          {currentProducts.map((product, index) => (
            <ProductCard
              key={product.id}
              product={product}
            />
          ))}
        </div>
        {!isLoading && filteredProducts.length > productsPerPage && <Pagination />}
        {isLoading && <p>Cargando productos...</p>}
      </div>
      {showFiltersModal && <FiltersModal />}
      <button 
        className="cart-toggle-btn"
        onClick={() => setShowCart(!showCart)}
      >
        <ShoppingCartIcon />
        <span className="cart-count">{cart.length}</span>
      </button>
      <Cart />
      
      {/* Reemplazar el modal existente del carrito con el nuevo componente */}
      {mostrarEnviosCarrito && <CartCheckoutModals />}
    </>
  );
};

export default LandingDrop;
